import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import themeColors from '../assets/styles/themeColors';
import { variables } from '../assets/styles/variables';
import { KYC_SELECTED_TYPE } from '../constants/sessionStorage';
import { storeInSessionStorage } from '../util/helpers/sessionStorageHelper';
import CheckIcon from './Icons/CheckIcon';
import ChevronRight from './Icons/ChevronRight';

import { ParagraphNormal, ParagraphNormalSub } from './Paragraph';

const FullContainer = styled.div`
  align-items: center;
  display: grid;
  gap: 10px;
  grid-template-columns: 40px 1fr 20px;
  margin: 5px 0;
  padding: 10px;
  cursor: ${({ isDone }) => (isDone ? 'not-allowed' : 'pointer')};
  background-color: ${themeColors.colorBackgroundSecondary};

  &:hover {
    background-color: ${themeColors.colorBackgroundSecondaryDark1};
  }
  ${({ isDone }) =>
    isDone &&
    `&:hover {
    background-color: ${themeColors.colorBackgroundSecondary};
  }`}
  border-radius: ${variables.borderRadius.borderRadius};
`;

const IconContainer = styled.div`
  width: 30px;
  height: 30px;
  background-color: ${themeColors.colorBackgroundSecondaryLight};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TitleContainer = styled.div`
  align-items: center;
  display: grid;
  gap: 10px;
  margin: 5px 0;
  padding: 10px;
`;

const KycSelectionContainer = ({
  title,
  subtitle,
  Icon,
  path,
  DocumentType,
  DocumenUid,
  HolderName,
  IsUploaded,
  PersonTargetType,
  SocureDocumentType,
  Caption,
  type,
  onClick,
}) => {
  const history = useHistory();

  return (
    <FullContainer
      onClick={() => {
        if (!IsUploaded) {
          onClick({
            DocumentType,
            DocumenUid,
            HolderName,
            IsUploaded,
            Caption,
            PersonTargetType,
            SocureDocumentType,
          });
          if (type) {
            storeInSessionStorage(KYC_SELECTED_TYPE, type);
          }
          history.push(path);
        }
      }}
      isDone={IsUploaded}
    >
      <IconContainer>
        {IsUploaded ? <CheckIcon isDone={IsUploaded} /> : <Icon />}
      </IconContainer>
      <TitleContainer>
        <ParagraphNormal isDone={IsUploaded} weight={600}>
          {title}
        </ParagraphNormal>
        {subtitle && (
          <ParagraphNormalSub weight={600} color={themeColors.colorTextLight}>
            {subtitle}
          </ParagraphNormalSub>
        )}
      </TitleContainer>
      {/* {subtitle && <ParagraphNormal weight={600}>{subtitle}</ParagraphNormal>} */}
      <ChevronRight w="10px" h="10px" />
    </FullContainer>
  );
};

KycSelectionContainer.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  path: PropTypes.string,
  type: PropTypes.string,
  DocumentType: PropTypes.number,
  DocumenUid: PropTypes.string,
  HolderName: PropTypes.string,
  IsUploaded: PropTypes.bool,
  PersonTargetType: PropTypes.number,
  Caption: PropTypes.string,
  SocureDocumentType: PropTypes.string,
  Icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.shape({ render: PropTypes.func.isRequired }),
  ]),
};

KycSelectionContainer.defaultProps = {
  onClick: Function.prototype,
};

export default KycSelectionContainer;
